import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function Home() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-8">
      <Card className="mt-6 border-border bg-card/80">
        <CardContent className="flex flex-col items-center px-6 py-10 text-center">
          <img
            src="/sbcc-logo.svg"
            alt="South Boston Challenge Club logo"
            width={96}
            height={96}
            className="mb-4 rounded-2xl"
          />
          <h1 className="mb-1 text-5xl font-semibold tracking-tight">Tears</h1>
          <p className="mb-6 text-base text-muted-foreground">
            South Boston Challenge Club — NFL Survivor
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Button asChild size="lg">
              <Link to="/auth">Log In / Register</Link>
            </Button>
            <Button asChild variant="secondary" size="lg">
              <Link to="/grid">View the Grid</Link>
            </Button>
            <Button asChild variant="outline" size="lg">
              <Link to="/info">League Info</Link>
            </Button>
          </div>
        </CardContent>
      </Card>

      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <FeatureCard title="Enter" index={0}>
          Create as many entries as you like.
        </FeatureCard>
        <FeatureCard title="Pick" index={1}>
          Win and advance; lose and you&apos;re out.
        </FeatureCard>
        <FeatureCard title="Win" index={2}>
          The last survivor secures 1st place.
        </FeatureCard>
      </div>

      <p className="mt-6 text-center text-muted-foreground">
        Curious about the details? Read the full{' '}
        <Link to="/info" className="text-primary underline-offset-4 hover:underline">
          league information
        </Link>{' '}
        or browse{' '}
        <Link to="/grid" className="text-primary underline-offset-4 hover:underline">
          the Grid
        </Link>{' '}
        to see this season&apos;s action.
      </p>
    </div>
  );
}

function FeatureCard({ title, index, children }) {
  return (
    <Card className={index % 2 === 0 ? 'bg-secondary' : 'bg-background'}>
      <CardHeader className="pb-2">
        <CardTitle className="text-xl">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="leading-relaxed text-foreground">{children}</p>
      </CardContent>
    </Card>
  );
}
